<tax-page-header
  [titleText]="kkm?.internalName"
  [showBackButton]="true"
  [dropdownItems]="dropdownItems"
>
  <tax-kkm-detail-header-info
    *ngIf="kkm && retailPlace"
    [kkm]="kkm"
    [retailPlace]="retailPlace"
  ></tax-kkm-detail-header-info>
</tax-page-header>

<tax-transactions-filter-form
  *ngIf="kkm"
  [kkm]="kkm"
  [userInfo]="userInfo$ | async"
  (formSubmitted)="applyFilter($event)"
></tax-transactions-filter-form>

<div class="shift" data-qa="transactions-list">
  <ng-container *ngIf="!transactionFilter?.reportType">
    <div
      *ngFor="let item of transactions"
      class="transaction-wrapper"
      [class.start-shift]="item.transactionType === 'OPEN_SHIFT'"
      [class.end-shift]="item.transactionType === 'CLOSE_SHIFT'"
    >
      <tax-transaction
        data-qa-link="transaction-page"
        (click)="openTicket(item)"
        [transaction]="item"
        [reports]="reports"
      ></tax-transaction>
      <hr class="greyline" />
    </div>
    <tax-empty-list
      *ngIf="transactions?.length === 0"
      text="transaction.empty.transactions"
    ></tax-empty-list>
  </ng-container>
  <ng-container
    *ngIf="
      transactionFilter?.reportType?.value === ReportTypeParam.X_REPORT ||
      transactionFilter?.reportType?.value === ReportTypeParam.Z_REPORT
    "
  >
    <div *ngFor="let item of reports" class="transaction-wrapper">
      <tax-report-transaction
        data-qa-link="report-page"
        (click)="openReport(item)"
        [transaction]="item"
      ></tax-report-transaction>
      <hr class="greyline" />
    </div>
    <tax-empty-list
      *ngIf="reports?.length === 0 && !reportIberica"
      [text]="
        transactionFilter?.reportType?.value === ReportTypeParam.X_REPORT
          ? 'transaction.empty.x-report'
          : 'transaction.empty.z-report'
      "
    ></tax-empty-list>
  </ng-container>
</div>

<tax-report-iberica
  *ngIf="reportIberica && transactionFilter?.reportType?.value === ReportTypeParam.IBERICA_REPORT"
  [report]="reportIberica"
  [userInfo]="userInfo$ | async"
></tax-report-iberica>

<tax-paginator
  *ngIf="kkm && !transactionFilter?.reportType"
  [total]="paginator.total"
  [pageIndex]="paginator.index"
  (nextPageEvent)="getPageData($event, kkm.id)"
  (previousPageEvent)="getPageData($event, kkm.id)"
></tax-paginator>
